import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "./common/Card";
import Grid from "@material-ui/core/Grid";
import Typography from "./common/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import crioLogo from "../../src/assets/crio-logo-white.svg";
import axios from "axios";
import Loader from "./common/Loader/Loader";

const styles = theme => ({
  top: {
    borderBottom: "1px solid" + theme.palette.primary.primaryBorder,
    padding: "0px 55px"
  },
  middle: {
    margin: "45px 55px"
  },
  subtitle: {
    display: "flex",
    alignItems: "center"
  },
  socialIcon: {
    color: theme.palette.primary.primary,
    fontSize: "32px",
    marginLeft: "20px"
  },
  arrowIcon: {
    color: theme.palette.primary.primary,
    marginLeft: "5px",
    cursor: "pointer"
  },
  programs: {
    margin: "35px 0px 30px 0px",
    color: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center"
  },

  programRow: { padding: "10px 0px 0px 0px" },
  MERow: {
    margin: "55px 0px 0px 0px"
    // borderBottom: "1px solid" + theme.palette.primary.primaryBorder
  },
  programPill: {
    display: "flex",
    alignItems: "center",
    background: "#3f3f3f",
    width: "fit-content",
    padding: "16px",
    borderRadius: "8px",
    margin: "10px 0px"
  }
});

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { meDetail: {}, user: "", isLoading: true };
    this.title = this.title.bind(this);
  }

  title(str) {
    return str.replace(/(^|\s)\S/g, function(t) {
      return t.toUpperCase();
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid container>
        <Grid row lg={2} md={1} xs={1}></Grid>
        <Grid row lg={7} md={10} xs={10}>
          <Card>
            <div className={classes.top}>
              <Typography fontSize="48px">
                {process.env.REACT_APP_FULL_NAME}
              </Typography>
              <div className={classes.subtitle}>
                <Typography fontSize="34px" color="rgba(0,0,0,0.6)">
                  Backend Developer
                </Typography>
                <a
                  href={process.env.REACT_APP_LINKEDIN}
                  target="_blank"
                  rel="noopener"
                >
                  <FontAwesomeIcon
                    icon={["fab", "linkedin"]}
                    className={classes.socialIcon}
                  ></FontAwesomeIcon>
                </a>
                <a
                  href={"http://github.com/" + process.env.REACT_APP_GITHUB}
                  target="_blank"
                  rel="noopener"
                >
                  <FontAwesomeIcon
                    icon={["fab", "github"]}
                    className={classes.socialIcon}
                  ></FontAwesomeIcon>
                </a>
              </div>
              <div className={classes.programs}>
                <Grid container>
                  <Grid item lg={1} md={1} xs={12}>
                    <Typography type="body2" color="rgba(0,0,0,0.6)">
                      Programs:
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    lg={5}
                    md={5}
                    xs={12}
                    style={{ marginLeft: "40px" }}
                  >
                    <Typography type="body2" color="#7C8DFF">
                      Product Development Program
                    </Typography>
                  </Grid>
                </Grid>
              </div>
              <a href={process.env.REACT_APP_CERTIFICATE_LINK} target="_blank">
                <div
                  className="viewCertificate"
                  style={{
                    padding: "10px",
                    border: "1px solid #7C8DFF",
                    width: "max-content",
                    borderRadius: "4px",
                    margin: "0px 0px 60px 0px",
                    display: "inline-flex",
                    alignItems: "center"
                  }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "file-alt"]}
                    style={{ marginRight: "10px" }}
                    className={classes.arrowIcon}
                  ></FontAwesomeIcon>
                  <Typography type="body2" color="#7C8DFF" cursor="pointer">
                    VIEW CERTIFICATE
                  </Typography>
                </div>
              </a>
            </div>
            <div className={classes.middle}>
              <Typography type="body1" color="rgba(0,0,0,0.6)">
                Crio Experience
              </Typography>
              <div className={classes.programRow}>
                <div className={classes.programPill}>
                  <img
                    alt="Crio.Do"
                    src={crioLogo}
                    style={{ marginRight: "10px" }}
                  ></img>
                  <Typography type="heading3" color="rgba(255,255,255,1)">
                    Product Development Program
                  </Typography>
                </div>
                <Typography type="body5" color="rgba(0,0,0,0.6)">
                  31 Oct 2019 - 29 Feb 2020
                </Typography>
              </div>
              <ul className="timeline">
                <li>
                  <div className={classes.MERow} class="meRow">
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography type="heading3" color="rgba(0,0,0,1)">
                          QTravel
                        </Typography>
                        <div style={{ marginTop: "16px" }}>
                          <Typography type="body5" color="rgba(0,0,0,1)">
                            QTravel is an app that helps travelers decide if it
                            is the right season to visit a city. The app takes
                            in the desired travel dates and returns the
                            appropriate weather forecast at the chosen
                            destination. In this Micro-Experience, developers
                            query third-party weather providers (via APIs) to
                            retrieve the data necessary to provide relevant
                            forecasts.
                          </Typography>
                          <div style={{ marginTop: "25px" }}>
                            <Grid container>
                              <Grid item xs={12} md={2}>
                                <Typography
                                  type="body5"
                                  color="rgba(0,0,0,0.6)"
                                >
                                  Skills Learned:
                                </Typography>
                              </Grid>
                              <Grid item xs={12} md={10}>
                                <Typography type="body5" color="rgba(0,0,0,1)">
                                  Java Interfaces, REST API, Factory Patterns,
                                  JUnit, Mockito
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                          <div style={{ margin: "30px 0px" }}>
                            <Grid container>
                              <Grid item xs={4}>
                                <Link
                                  to={{
                                    pathname:
                                      "/crio-pdp-2019-" +
                                      process.env.REACT_APP_GITHUB +
                                      "/detail/ME_JAVA_WARMUP_V2",
                                    aboutProps: {
                                      getMeDetails: this.getMeDetails,
                                      data: this.state.meDetail[
                                        "ME_JAVA_WARMUP_V2"
                                      ],
                                      getTitle: this.props.getTitle
                                    }
                                  }}
                                >
                                  <Typography
                                    type="body5"
                                    color="#7C8DFF"
                                    cursor="pointer"
                                  >
                                    VIEW DETAILS
                                    <FontAwesomeIcon
                                      icon={["fas", "arrow-right"]}
                                      className={classes.arrowIcon}
                                    ></FontAwesomeIcon>
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </li>
                <div
                  style={{
                    marginLeft: "80px",
                    borderBottom: "1px solid #d8d8d8",
                    marginBottom: "30px"
                  }}
                ></div>
                <li>
                  <div className={classes.MERow} class="meRow">
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography type="heading3" color="rgba(0,0,0,1)">
                          QEats
                        </Typography>
                        <div style={{ marginTop: "16px" }}>
                          <Typography type="body5" color="rgba(0,0,0,1)">
                            QEats is a popular food ordering app that allows
                            users to browse and order their favorite dishes from
                            nearby restaurants. During the course of this
                            Micro-Experience, developers build different parts
                            of the QEats backend which is a Spring Boot
                            application. Several REST API endpoints are
                            implemented to query restaurant information and
                            place food orders. To give a sense of real-world
                            problems, production issues are introduced for the
                            developer to investigate using Scientific Debugging
                            methods. Along with this, the developer is expected
                            to improve the app performance under large load
                            scenarios as well as include an advanced search
                            feature in the app.
                          </Typography>
                          <div style={{ marginTop: "25px" }}>
                            <Grid container>
                              <Grid item xs={12} md={2}>
                                <Typography
                                  type="body5"
                                  color="rgba(0,0,0,0.6)"
                                >
                                  Skills Learned:
                                </Typography>
                              </Grid>
                              <Grid item xs={12} md={10}>
                                <Typography type="body5" color="rgba(0,0,0,1)">
                                  Spring Boot, REST API, MongoDB, Redis, JUnit,
                                  Mockito
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                          <div style={{ margin: "40px 0px" }}>
                            <Grid container>
                              <Grid item xs={4}>
                                <Link
                                  to={{
                                    pathname:
                                      "/crio-pdp-2019-" +
                                      process.env.REACT_APP_GITHUB +
                                      "/detail/ME_QEATS",
                                    aboutProps: {
                                      data: this.state.meDetail["ME_QEATS"],
                                      getTitle: this.props.getTitle
                                    }
                                  }}
                                >
                                  <Typography
                                    type="body5"
                                    color="#7C8DFF"
                                    cursor="pointer"
                                  >
                                    VIEW DETAILS
                                    <FontAwesomeIcon
                                      icon={["fas", "arrow-right"]}
                                      className={classes.arrowIcon}
                                    ></FontAwesomeIcon>
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </li>
                <div
                  style={{
                    marginLeft: "80px",
                    borderBottom: "1px solid #d8d8d8",
                    marginBottom: "30px"
                  }}
                ></div>
                <li>
                  <div className={classes.MERow} class="meRow">
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography type="heading3" color="rgba(0,0,0,1)">
                          QMoney Stock Analyzer
                        </Typography>
                        <div style={{ marginTop: "16px" }}>
                          <Typography type="body5" color="rgba(0,0,0,1)">
                            QMoney Stock Analyzer is a tool to help users get
                            useful data about their stock portfolios. In this
                            Micro-Experience, developers query third-party stock
                            quote services (via APIs) and generate metrics such
                            as volatility and daily/annualized returns to
                            analyze stocks present in their portfolios.
                          </Typography>
                          <div style={{ marginTop: "25px" }}>
                            <Grid container>
                              <Grid item xs={12} md={2}>
                                <Typography
                                  type="body5"
                                  color="rgba(0,0,0,0.6)"
                                >
                                  Skills Learned:
                                </Typography>
                              </Grid>
                              <Grid item xs={12} md={10}>
                                <Typography type="body5" color="rgba(0,0,0,1)">
                                  Java Interfaces, REST API, Factory Patterns,
                                  Mockito
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                          <div style={{ margin: "50px 0px" }}>
                            <Grid container>
                              <Grid item xs={4}>
                                <Link
                                  to={{
                                    pathname:
                                      "/crio-pdp-2019-" +
                                      process.env.REACT_APP_GITHUB +
                                      "/detail/ME_STOCK_ANALYZER",
                                    aboutProps: {
                                      data: this.state.meDetail[
                                        "ME_STOCK_ANALYZER"
                                      ],
                                      getTitle: this.props.getTitle
                                    }
                                  }}
                                >
                                  <Typography
                                    type="body5"
                                    color="#7C8DFF"
                                    cursor="pointer"
                                  >
                                    VIEW DETAILS
                                    <FontAwesomeIcon
                                      icon={["fas", "arrow-right"]}
                                      className={classes.arrowIcon}
                                    ></FontAwesomeIcon>
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </li>
              </ul>
            </div>
          </Card>
        </Grid>
        <Grid row lg={2} md={1} xs={1}></Grid>
      </Grid>
    );
  }
}
export default withStyles(styles)(Home);
